import React from 'react';
import styled from 'styled-components';
import AlertInformation from '../components/AlertInformation';

const Bold = styled.span`
  font-weight: bold;
`;

const Covid = () => {
  return (
    <div>
      <h1>COVID 19</h1>
      <p>
        <Bold>Coronavirus disease (COVID-19)</Bold> is an infectious disease caused by
        a newly discovered coronavirus. The COVID-19 virus spreads primarily
        through droplets of saliva or discharge from the nose when an
        infected person coughs or sneezes. Recent government guidance has
        now permitted the treatment of non-emergency cases within the
        chiropractic sector so please read carefully the below details on
        what changes you will expect to see upon your next appointment both
        with your treatment and your practitioner and also your own roles
        and responsibilities.
      </p>
      <p>
        Patient and practitioner safety is paramount, so in order to achieve
        this new measures and additional precautions have been implemented.
      </p>

      <h2>Know the signs and symptoms</h2>
      <p>
        Please do not book an appointment or attend an already booked
        appointment if you have any of the following signs or
        symptoms within the last 14 days:
      </p>
      <h3>Most common symptons</h3>
      <ul>
        <li>Fever</li>
        <li>Dry cough</li>
        <li>Tiredness</li>
      </ul>

      <h3>Less common symptoms</h3>
      <ul>
        <li>Severe, flu-like aches and pains</li>
        <li>Sore throat</li>
        <li>Diarrhoea</li>
        <li>Conjunctivitis</li>
        <li>Loss of taste or smell</li>
        <li>A rash on skin, or discolouration of fingers or toes</li>
      </ul>

      <h3>Serious symptoms</h3>
      <ul>
        <li>Difficulty breathing or shortness of breath</li>
        <li>Chest pain or pressure</li>
        <li>Loss of speech or movement</li>
      </ul>

      <p>
        Seek immediate medical attention if you have serious symptoms. 
        Always call before visiting your doctor or health facility. 
      </p>

      <h2>What changes can I expect going forward?</h2>
      <ul>
        <li>
          Before an appointment is confirmed a <Bold>triage assessment</Bold> will take
          place over the phone. Questions will include disclosure of any
          previous Covid 19 signs or symptoms, whether you are shielding
          or caring for a shielding person. The outcome of this
          tele-consultation will determine if a patient can then visit the
          clinic or not.
        </li>
        <li>
          Upon arrival <Bold>hand sanitiser</Bold> will be provided and
          your <Bold>temperature</Bold> will be taken. If your temperature
          is above 37.8 degrees celsius, treatment will be refused.
          Covid 19 testing and isolation measures as per government
          guidelines should then be followed. If your temperature is
          normal, a second triage assessment will then take place
          before any treatment can commence and you will be invited to
          read and sign the clinic Covid 19 risk assessment, disclosure
          and consent form.
        </li>
        <li>
          Your practitioner will be in appropriate <Bold>PPE</Bold> (mask,
          apron andgloves) which will be discarded after each
          patient. <Bold>You</Bold> must wear a <Bold>face</Bold> mask
          (one can be provided at a cost of £1 if you do not have your
          own) and also remove as many outer layers of clothing as
          practical before coming into the clinic. Please wear sports
          or loose fitting clothing for your treatment.
        </li>
        <li>
          Please attend your appointment <Bold>alone</Bold> unless
          absolutely necessary (child care etc) and keep to your
          appointment time. Lateness will result in cancellation of
          the appointment and you will still be charged for the time.
        </li>
        <li>
          The clinic will <Bold>deep cleaned</Bold> in between patients.
          Please try not to use the toilet unless absolutely necessary.
        </li>
        <li>
          To reduce the risk of viral load, treatment
          times <Bold>may be shorter</Bold> than usual to minimise the time
          a chiropractor will be in contact with a patient.
        </li>
        <li>
          These changes are subject to change as we continue to monitor
          government guidance.
        </li>
      </ul>
      <p>
        These are truly unprecedented times and we thank you for
        your patience.
      </p>
    </div>
  );
};

export default Covid;



// WEBPACK FOOTER //
// ./src/pages/covid.js